// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__B-XeL","spin":"Loader_spin__kTCPw"};